import { Section } from "@/types/section";
import { Info } from "@/types/info";

export class CvService {
  private url: string;

  constructor() {
    this.url = process.env.VUE_APP_CV_API;
  }

  getSections(): Section[] {
    return sectionJSON;
  }
  getInfo(): Info {
    return infoJSON;
  }
}

export const CvApi: CvService = new CvService();

let sectionJSON: Section[] = JSON.parse(`
[
  {
    "id": "c9431a52-9c14-435f-88c6-37fb5743f0bc",
    "order": 1,
    "title": "Experience",
    "rows": [
      {
        "id": "a12f9394-b62d-4bc1-af59-75c9be24693e",
        "title": "Neo4j",
        "header": "Site Reliability Engineer",
        "link": "https://www.neo4j.com/",
        "subheading": "Malmö, Sweden",
        "content": "Making sure Neo4j's Database as a Service (DBaaS) Neo4j Aura is available and working as intended.",
        "timespan": "01-2020 - current",
        "order": 2
      },
      {
        "id": "085d7be1-28d6-4d4e-82b4-3ba8808e0b5e",
        "title": "Apsis AB",
        "header": "Devops / Backend Developer",
        "link": "https://www.apsis.com/",
        "subheading": "Malmö, Sweden",
        "content": "Building and maintaining CI/CD pipelines, infrastructure and code in the cloud utilizing Amazon Web Services. Using AWS services like CloudFormation, DynamoDB, RDS, EC2/ECS, SQS, Lambda, API Gateway, S3, Secrets Manager etc. and creating developing services in Golang and TypeScript",
        "timespan": "06-2016 - 01-2020",
        "order": 2
      },
      {
        "id": "0f444dd3-74c1-4ecd-8a9b-b488845f4c57",
        "title": "Malmö University",
        "header": "Exercise supervisor",
        "link": "https://www.mau.se/",
        "subheading": "Malmö, Sweden",
        "content": "Part time as a supervisor for students of programming exercises and workshops. Both theoretical tasks as well as real programming exercises mostly in Java.",
        "timespan": "08-2015 - 12-2016",
        "order": 3
      }
    ]
  },
  {
    "id": "70e95f19-4b37-4a7e-9750-c28e4be12bbe",
    "order": 2,
    "title": "Education",
    "rows": [
      {
        "id": "1cc4a7ac-b4bd-4c37-8d57-86eb0af4f55a",
        "title": "Luleå University of Technology",
        "header": "Master's degree",
        "link": "https://www.ltu.se/",
        "subheading": "Computer and Information Systems Security/Information Assurance",
        "timespan": "2017 - 2019",
        "order": 1
      },
      {
        "id": "81469b8a-3048-44d4-a300-5d577d3ad217",
        "title": "Malmö University",
        "header": "Bachelor of Science (B.Sc.)",
        "link": "https://www.mau.se/",
        "subheading": "Computer Systems Development",
        "timespan": "2014 - 2017",
        "order": 2
      }
    ]
  },
  {
    "id": "0aad7512-90fb-4e92-af16-4435dc8b5988",
    "order": 3,
    "title": "Projects",
    "rows": [
      {
        "id": "a9795fd6-aaed-4d68-ba24-cdbd66fc7132",
        "title": "s3-upload",
        "header": "GitHub Action",
        "link": "https://github.com/JimmyMaksymiw/s3-upload/",
        "subheading": "something",
        "timespan": "2019",
        "content": "GitHub Action which syncs a specified folder with a s3 bucket.",
        "order": 1
      }
    ]
  }
]
`);

let infoJSON: Info = JSON.parse(`
{
  "id": "7cfd7fc2-25ab-44d5-ab7b-f110bcf0bfe6",
  "title": "Jimmy Masymiw",
  "subtitle": "- Cloud enthusiast",
  "avatar": "./img/avatar.jpg",
  "description": "Hello, \\n\\n Welcome to my resume. I'm a curious and driven software engineer who strive to learn new techniques with a passion for the cloud.",
  "tags": [
    "Site Reliability Engineer",
    "DevOps",
    "Graphs",
    "Information Security",
    "Cloud technology"
  ],
  "contact": [
    {
      "title": "Email",
      "link": "mailto:jimmy.maksymiw@gmail.com",
      "iconSrc": "./img/mail.svg"
    },
    {
      "title": "GitHub",
      "link": "https://github.com/JimmyMaksymiw",
      "iconSrc": "./img/github.svg"
    },
    {
      "title": "LinkedIn",
      "link": "https://www.linkedin.com/in/jimmy-maksymiw",
      "iconSrc": "./img/linkedin.svg"
    }
  ]
}
`);
